import builtInConfig from 'config/config_server.json';

function get (key) {
  const override = getExternalCfg();
  if (override && override.hasOwnProperty(key)) {
    return override[key];
  } else {
    return builtInConfig[key];
  }
}

function getExternalCfg () {
  return null;
}

function getLocal (key) {
  return localStorage.getItem(key);
}

function isEditEnabled () {
  return true || getLocal('__ar_edit__') === 'true';
}

export default {
  get,
  isEditEnabled
};



/** WEBPACK FOOTER **
 ** ./src/services/configService.js
 **/